class ProductSwatches extends HTMLElement {
  constructor() {
    super();

    this.items = document.querySelectorAll('[data-group-item]');
    this.colorLabel = document.querySelector('[data-group-label]');
    this.wrapper = this.querySelector('[data-variant-selector-wrapper]');
    this.trigger = this.querySelectorAll('[data-variant-selector-toggle]');

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', (e) => {
        this.updateLabel(e.currentTarget.dataset.groupItem);
      });
      item.addEventListener('mouseleave', () => {
        this.updateLabel();
      });
      item.addEventListener('click', () => {
        if (window.innerWidth < 768) {
          this.toggle();
        }
      });
    });
    this.toggle();
  }

  updateLabel(label) {
    if (!label) {
      label = this.colorLabel.dataset.groupLabel;
    }
    this.colorLabel.innerHTML = label;
  }
  toggle() {
    this.trigger.forEach((btn) => {
      btn.addEventListener('click', () => this.wrapper.classList.toggle('product__variant-selector--open'));
    });
  }
}

if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches);
}
